// Auto-extracted schema
export const WAIS4_SUBTESTS = [
  { var: "cubos", label: "Construcción con cubos (Diseño con cubos):" },
  { var: "analogias", label: "Analogías (Semejanzas):" },
  { var: "retencion_de_digitos", label: "Retención de dígitos:" },
  { var: "matrices_de_razonamiento", label: "Matrices de razonamiento:" },
  { var: "vocabulario", label: "Vocabulario:" },
  { var: "aritmetica", label: "Arimética:" },
  { var: "busqueda_de_simbolos", label: "Búsqueda de símbolos:" },
  { var: "rompecabezas_visuales", label: "Rompecabezas visuales:" },
  { var: "informacion", label: "Información:" },
  { var: "claves", label: "Claves:" },
  { var: "secuenciacion_letras_numeros", label: "Secuenciación Letras-Números:" },
  { var: "balanzas", label: "Balanzas (Peso figurado):" },
  { var: "comprension", label: "Comprensión:" },
  { var: "cancelacion", label: "Cancelación:" },
  { var: "figuras_incompletas", label: "Figuras incompletas:" },
];

export const WAIS4_CONFIG = [
  { var: "metodo_discrepancia", label: "Método para calcular la discrepancia:", options: [
    { value: "valor_critico", text: "Valor crítico" },
    { value: "muestra_total", text: "Tasa base: Comparar con Muestra total" },
    { value: "igual_capacidad", text: "Tasa base: Comparar con Nivel de habilidad" },
  ]},
  { var: "tasa_base_significante", label: "Tasa base significante:", options: [
    { value: "5", text: "5%" },
    { value: "6", text: "6%" },
    { value: "7", text: "7%" },
    { value: "8", text: "8%" },
    { value: "9", text: "9%" },
    { value: "10", text: "10%" },
    { value: "11", text: "11%" },
    { value: "12", text: "12%" },
    { value: "13", text: "13%" },
    { value: "14", text: "14%" },
    { value: "15", text: "15% (recomendado)" },
    { value: "16", text: "16%" },
    { value: "17", text: "17%" },
    { value: "18", text: "18%" },
    { value: "19", text: "19%" },
    { value: "20", text: "20%" },
    { value: "21", text: "21%" },
    { value: "22", text: "22%" },
    { value: "23", text: "23%" },
    { value: "24", text: "24%" },
    { value: "25", text: "25%" },
    { value: "26", text: "26%" },
    { value: "27", text: "27%" },
    { value: "28", text: "28%" },
    { value: "29", text: "29%" },
    { value: "30", text: "30%" },
    { value: "31", text: "31%" },
    { value: "32", text: "32%" },
    { value: "33", text: "33%" },
    { value: "34", text: "34%" },
    { value: "35", text: "35%" },
  ]},
  { var: "tipo", label: "Tipo de puntaje:", options: [
    { value: "Bruto", text: "Bruto" },
    { value: "Equivalente", text: "Equivalente" },
  ]},
  { var: "pais", label: "País:", options: [
    { value: "Chile", text: "Chile" },
    { value: "Mexico", text: "México" },
    { value: "Venezuela", text: "Venezuela" },
  ]},
  { var: "confianza", label: "Nivel de confianza:", options: [
    { value: "95%", text: "95%" },
    { value: "90%", text: "90%" },
  ]},
];

export const WAIS4_DEFAULTS = {"metodo_discrepancia": "valor_critico", "tasa_base_significante": "15", "tipo": "Bruto", "pais": "Chile", "confianza": "95%"};
